interface ITable {
  bordered?: boolean;
  locale: any;
  size?: 'small' | 'middle';
  scroll?: {
    x: number | true | 'max-content';
  };
}

const isCompactViewport = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.matchMedia('(max-width: 991px)').matches;
};

const table: ITable = {
  locale: {
    emptyText: 'Nenhum dado a ser exibido.',
  },
  size: 'small',
  bordered: false,
  scroll: { x: isCompactViewport() ? 'max-content' : true },
};

export default table;
